import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Styles from './RevenueTrendCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { ChartComponent, IFText, IFSkeleton } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { formatNumber } from 'Utils/Calculations'
import { useTranslation } from 'react-i18next'
import AuthSelectors from 'Stores/Auth/Selectors'

const RevenueTrendCard = ({
  revenueTrend,
  fetchRevenueTrend,
  fetchRevenueTrendRequestState,
  filter,
  operator,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    fetchRevenueTrend(filter)
  }, [filter])
  const graphArray = revenueTrend?.data?.graph ?? []

  const series = [
    {
      name: 'Revenue',
      data: graphArray.map((point) => {
        const d = new Date(point.date)
        return {
          x: d,
          y: point.amount,
        }
      }),
    },
  ]

  const hasAnyNonZero = graphArray.some((p) => Number(p.amount) !== 0)
  const isEmptySeries = graphArray.length === 0 || !hasAnyNonZero

  const options = {
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: [Colors.primary],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        shadeIntensity: 0.2,
        gradientToColors: [Colors.Analytics.GraphGradient],
        opacityFrom: 0.6,
        opacityTo: 0.1,
        stops: [0, 100],
        inverseColors: false,
        type: 'vertical',
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        format: 'dd/MM/yyyy',
        style: { colors: Colors.Analytics.AnalyticsDataGreyText },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => formatNumber(val),
        style: { colors: Colors.Analytics.AnalyticsDataGreyText },
      },
    },
    grid: { show: false },
    tooltip: {
      x: {
        formatter: (val) => {
          const date = new Date(val)
          const day = String(date.getDate()).padStart(2, '0')
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const year = date.getFullYear()
          return `${day}/${month}/${year}`
        },
      },
      y: {
        formatter: (val) =>
          `${formatNumber(val)} ${operator.country.currency.code}`,
      },
    },
  }

  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <div className={Styles.GraphContainer}>
        {fetchRevenueTrendRequestState === RequestState.LOADING ? (
          <div className={Styles.ChartSkeleton}>
            <IFSkeleton width={'100%'} height={'100%'} variant="rectangular" />
          </div>
        ) : (
          <div className={Styles.Chart}>
            <ChartComponent
              options={options}
              series={series}
              height="100%"
              width="100%"
              type="area"
              className={isEmptySeries ? Styles.OverlayTest : Styles.Test}
            />

            {isEmptySeries && (
              <IFText
                className={Styles.OverlayText}
                style={{ color: Colors.red }}
              >
                {t('ConnectorUtilization.NoData')}
              </IFText>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  revenueTrend: AnalyticsSelectors.getRevenueTrend(state),
  fetchRevenueTrendRequestState:
    AnalyticsSelectors.getRevenueTrendRequestState(state),
  operator: AuthSelectors.getOperator(state),
})
function mapDispatchToProps(dispatch) {
  return {
    fetchRevenueTrend: (filter) =>
      dispatch(AnalyticsActions.fetchRevenueTrend(filter)),
  }
}
RevenueTrendCard.propTypes = {
  filter: PropTypes.object,
  fetchRevenueTrend: PropTypes.func,
  fetchRevenueTrendRequestState: PropTypes.number,
  revenueTrend: PropTypes.object,
  operator: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(RevenueTrendCard)
